import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { BASE_URL } from '../config/api'; // Assuming BASE_URL is correctly defined in your config/api.js

const EditDayStartClose = () => {
    const { id } = useParams(); // Get the entry ID from the URL
    const navigate = useNavigate();

    // State for holding the data to be updated
    const [counter, setCounter] = useState('');
    const [type, setType] = useState('');
    const [voucherDate, setVoucherDate] = useState('');
    const [time, setTime] = useState('');
    const [sno, setSno] = useState('');
    const [denomination, setDenomination] = useState('');
    const [number, setNumber] = useState('');
    const [amount, setAmount] = useState('');

    // Fetch the current data when the component mounts
    useEffect(() => {
        fetch(`${BASE_URL}daystartclose/${id}`)
            .then(response => response.json())
            .then(data => {
                if (data.status === 'success') {
                    const entry = data.data;
                    setCounter(entry.counter);
                    setType(entry.type);
                    setVoucherDate(entry.voucher_date);
                    setTime(entry.time);
                    setSno(entry.sno);
                    setDenomination(entry.denomination);
                    setNumber(entry.number);
                    setAmount(entry.amount);
                }
            })
            .catch(error => console.error('Error fetching day start/close entry:', error));
    }, [id]);

    // Handle form submission
    const handleSubmit = (event) => {
        event.preventDefault();

        const updatedEntry = {
            counter,
            type,
            voucher_date: voucherDate,
            time,
            sno,
            denomination,
            number,
            amount
        };

        fetch(`${BASE_URL}daystartclose/${id}`, {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(updatedEntry),
        })
            .then(response => response.json())
            .then(data => {
                if (data.status === 'success') {
                    alert('Entry updated successfully!');
                    navigate('/DayStartCloseList'); // Redirect to the list page after update
                } else {
                    alert('Error updating entry. Please try again.');
                }
            })
            .catch(error => console.error('Error updating day start/close entry:', error));
    };

    return (
        <div id="main">
            <header className="mb-3">
                <a href="#" className="burger-btn d-block d-xl-none">
                    <i className="bi bi-justify fs-3"></i>
                </a>
            </header>

            <div className="page-heading">
                <div className="page-title">
                    <div className="row">
                        <div className="col-12 col-md-6 order-md-1 order-last">
                            <h3>Edit Day Start/Close Entry</h3>
                        </div>
                    </div>
                </div>
            </div>

            {/* Edit Form */}
            <section className="section">
                <div className="row">
                    <div className="col-12 col-md-12">
                        <div className="card">
                            <div className="card-header">
                                <h4 className="card-title">Edit Entry Details</h4>
                            </div>
                            <div className="card-body">
                                <form onSubmit={handleSubmit}>
                                    <div className="mb-3">
                                        <label htmlFor="counter" className="form-label">Counter</label>
                                        <input
                                            type="text"
                                            id="counter"
                                            className="form-control"
                                            value={counter}
                                            onChange={(e) => setCounter(e.target.value)}
                                            required
                                        />
                                    </div>
                                    <div className="mb-3">
                                        <label htmlFor="type" className="form-label">Type</label>
                                        <select
                                            id="type"
                                            className="form-control"
                                            value={type}
                                            onChange={(e) => setType(e.target.value)}
                                            required
                                        >
                                            <option value="start">Start</option>
                                            <option value="close">Close</option>
                                        </select>
                                    </div>
                                    <div className="mb-3">
                                        <label htmlFor="voucherDate" className="form-label">Voucher Date</label>
                                        <input
                                            type="date"
                                            id="voucherDate"
                                            className="form-control"
                                            value={voucherDate}
                                            onChange={(e) => setVoucherDate(e.target.value)}
                                            required
                                        />
                                    </div>
                                    <div className="mb-3">
                                        <label htmlFor="time" className="form-label">Time</label>
                                        <input
                                            type="time"
                                            id="time"
                                            className="form-control"
                                            value={time}
                                            onChange={(e) => setTime(e.target.value)}
                                            required
                                        />
                                    </div>
                                    <div className="mb-3">
                                        <label htmlFor="sno" className="form-label">Sno</label>
                                        <input
                                            type="number"
                                            id="sno"
                                            className="form-control"
                                            value={sno}
                                            onChange={(e) => setSno(e.target.value)}
                                            required
                                        />
                                    </div>
                                    <div className="mb-3">
                                        <label htmlFor="denomination" className="form-label">Denomination</label>
                                        <input
                                            type="number"
                                            id="denomination"
                                            className="form-control"
                                            value={denomination}
                                            onChange={(e) => setDenomination(e.target.value)}
                                            required
                                        />
                                    </div>
                                    <div className="mb-3">
                                        <label htmlFor="number" className="form-label">Number</label>
                                        <input
                                            type="number"
                                            id="number"
                                            className="form-control"
                                            value={number}
                                            onChange={(e) => setNumber(e.target.value)}
                                            required
                                        />
                                    </div>
                                    <div className="mb-3">
                                        <label htmlFor="amount" className="form-label">Amount</label>
                                        <input
                                            type="number"
                                            id="amount"
                                            className="form-control"
                                            value={amount}
                                            onChange={(e) => setAmount(e.target.value)}
                                            required
                                        />
                                    </div>
                                    <div className="text-end">
                                        <button type="submit" className="btn btn-primary">Update Entry</button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            {/* End Edit Form */}
        </div>
    );
};

export default EditDayStartClose;
